import { render, staticRenderFns } from "./SettingsManager.vue?vue&type=template&id=42bbe99e&"
import script from "./SettingsManager.vue?vue&type=script&lang=js&"
export * from "./SettingsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports